import React, { useState } from "react";
import Popup from "./Popup";

import { FieldValues, SubmitHandler, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { setBooking } from "../../reducer/bookingSlice";
import FormButton from "../form/formButton/FormButton";
import FormInput from "../form/formInput/FormInput";
import FormSelect from "../form/formSelect/FormSelect";
import { IRootState } from "../../reducer/store";

type PropType = {
  onClose: () => void;
};

const ModifyPopup = ({ onClose }: PropType) => {
  const booking = useSelector(
    (state: IRootState) => state.booking.value.booking
  );
  const dispatch = useDispatch();

  const [bookingType, setBookingType] = useState<"single" | "return">("single");

  const { register, formState, handleSubmit, control } = useForm();
  const onBookRide: SubmitHandler<FieldValues> = (formData) => {
    console.log(formData);
    dispatch(
      setBooking({
        from: formData.from.value,
        to: formData.to.value,
        departureDate: formData.data,
        returnDate: formData.date,
        adult: formData.adults,
        children: formData.children,
      })
    );
    onClose();
  };
  return (
    <Popup onClose={onClose} title="Modify">
      <div className="px-4">
        <div className="flex items-center font-semibold text-sm mb-4 gap-5">
          <div
            className={`flex gap-2 items-center p-2 px-4 cursor-pointer ${
              bookingType === "single"
                ? "bg-[#B9000A] text-white"
                : "bg-white text-[#B9000A]"
            }`}
            onClick={() => setBookingType("single")}
          >
            Single
          </div>
          <div
            className={`flex gap-2 items-center p-2 px-4 cursor-pointer ${
              bookingType === "return"
                ? "bg-[#B9000A] text-white"
                : "bg-white text-[#B9000A]"
            }`}
            onClick={() => setBookingType("return")}
          >
            Return
          </div>
        </div>
        {bookingType === "single" && (
          <form onSubmit={handleSubmit(onBookRide)}>
            <FormSelect
              color="blue"
              control={control}
              formState={formState}
              label="Traveling From"
              name="from"
              defaultValue={booking.from}
              options={[
                { label: "Lagos", value: "Lagos" },
                { label: "Kano", value: "Kano" },
              ]}
              rules={{ required: "select one" }}
              placeholder="Enter departure loacation"
            />

            <FormSelect
              color="blue"
              control={control}
              formState={formState}
              label="Traveling To"
              defaultValue={booking.to}
              name="to"
              options={[
                { label: "Abuja", value: "Abuja" },
                { label: "Kogi", value: "Kogi" },
              ]}
              rules={{ required: "select one" }}
              placeholder="Enter destination loacation"
            />
            <FormInput
              formState={formState}
              name="date"
              placeholder="Enter date"
              label="Destination Date"
              register={register}
              rules={{ required: "Select date" }}
              type="date"
              color="white"
              defaultValue={booking.returnDate}
            />
            <div className="grid grid-cols-2 gap-3">
              <FormInput
                formState={formState}
                name="adults"
                placeholder="1"
                defaultValue={booking.adult.toString()}
                label="Adults"
                register={register}
                rules={{}}
                type="number"
                color="white"
              />
              <FormInput
                formState={formState}
                name="children"
                placeholder="1"
                label="Children"
                defaultValue={booking.children.toString()}
                register={register}
                rules={{}}
                type="number"
                color="white"
              />
            </div>

            <FormButton small error={false} label="Proceed" loading={false} />
          </form>
        )}
      </div>
    </Popup>
  );
};

export default ModifyPopup;
